import { PropType, reactive } from 'vue';
import { useNotif } from '@orion.ui/orion';
import BaseSetupService from '@/setup/BaseSetupService';
import UserProfileCommentApiClient from '@/api/UserProfileCommentApiClient';
import UserProfileCommentApiAgency from '@/api/UserProfileCommentApiAgency';

type Props = SetupProps<typeof TempWorkerCommentListSetupService.props>

export default class TempWorkerCommentListSetupService extends BaseSetupService<Props> {
	static readonly props = {
		commentList: {
			type: Array as PropType<IUserProfileCommentModel[]>,
			default: () => [],
		},
		candidateId: {
			type: Number,
			required: true as const,
		},
		commentType: {
			type: Number,
			required: true as const,
		},
	};

	private readonly state = reactive({
		isFocused: false,
		comment: undefined as Undef<string>,
		isSendingComment: false,
		commentTypeOptions: {
			ProfileComment: 1,
			// Ajouter les autres types de commentaire possible
		},
	});


	get api () { return this.self.isClient() ? UserProfileCommentApiClient : UserProfileCommentApiAgency; }
	get isProfileCommentType () { return this.props.commentType === this.state.commentTypeOptions.ProfileComment; }
	get orderedComments () { return [...this.props.commentList].sort((a, b) => new Date(b.createdDate).valueOf() - new Date(a.createdDate).valueOf()); }
	get isSendingComment () { return this.state.isSendingComment; }

	get isFocused () { return this.state.isFocused; }
	set isFocused (val) { this.state.isFocused = val; }

	get comment () { return this.state.comment; }
	set comment (val) { this.state.comment = val; }


	constructor (props?: Props) {
		super(props);
	}


	async addCommentAsync () {
		this.state.isSendingComment = true;

		if (this.isProfileCommentType) {
			const { data } = await this.api.add({
				comment: this.comment,
				userId: this.props.candidateId,
			});
			this.props.commentList.push(data);
		}

		this.state.comment = undefined;
		this.state.isSendingComment = false;
		useNotif.success('Commentaire ajouté');
	}

	async deleteCommentAsync (id: number) {
		if (this.isProfileCommentType) await this.api.delete(id);
		this.props.commentList.deleteWhere('id', id);
		useNotif.success('Commentaire supprimé');
	}

	resetCommentInput () {
		this.state.comment = undefined;
	}
}
